import type { ITermRange } from '@src/@types/ranges';
import { isoDurationToDays } from '@src/helpers/date';

export const getCardTerm = (term: ITermRange) => {
  // Получаем строки чисел без слова "от/до"
  const { from, to } = term;

  if (!from && !to) return '';

  const newFrom = isoDurationToDays(from);
  const newTo = isoDurationToDays(to);

  if (newFrom === newTo) {
    return newFrom;
  }

  return [newFrom, newTo].join(' - ');
};
